import React, { useState } from 'react';
import './ProductGallery.css';

interface ProductGalleryProps {
  images: string[];
  title: string;
}

const ProductGallery: React.FC<ProductGalleryProps> = ({ images, title }) => {
  const [selected, setSelected] = useState(0);

  return (
    <div className="product-gallery">
      {/* Thumbnails */}
      <div className="product-gallery__thumbs" aria-label="Product images">
        {images.map((src, i) => (
          <button
            key={i}
            className={`product-gallery__thumb ${i === selected ? 'product-gallery__thumb--active' : ''}`}
            onClick={() => setSelected(i)}
            aria-label={`View ${title} — photo ${i + 1} of ${images.length}`}
          >
            <img src={src} alt="" width={72} height={90} />
          </button>
        ))}
      </div>

      {/* Main image */}
      <div className="product-gallery__main">
        <img
          key={selected}
          src={images[selected]}
          alt={`${title}, view ${selected + 1} of ${images.length}`}
          className="product-gallery__main-image"
          width={600}
          height={750}
        />

        {/* Mobile indicators */}
        {images.length > 1 && (
          <div className="product-gallery__dots" aria-hidden="true">
            {images.map((_, i) => (
              <button
                key={i}
                className={`product-gallery__dot ${i === selected ? 'product-gallery__dot--active' : ''}`}
                onClick={() => setSelected(i)}
                tabIndex={-1}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductGallery;
